module.exports = __webpack_public_path__ + "static/media/presentationMaker.1b53bbe1.svg";